import type { QueryType } from '../../types/api';
import type { AppApolloClient } from '../../types/common-models';
import { ParentMessageQuery } from '../Discussion/query';

/**
 * Rule about collapsed messages on the yakli page:
 * if there are <= 5 collapsed messages, we must initially fetch them. Intermediate messages are collapsed from 6 "collapsible" messages.
 */
export async function completeDiscussionQueryData(data: QueryType, apolloClient: AppApolloClient) {
  const position =
    data.website?.findTopic?.findOrCreateThread?.positionLevelCommentInDiscussionYakli;
  const ancestorMessage = data.website?.findMessage?.parentMessage;
  const ancestorMessageId = ancestorMessage?.id;

  if (position == null || !(position <= 7) || !ancestorMessageId || ancestorMessage.parentMessage) {
    return false;
  }

  const { data: data2 } = await apolloClient.query<QueryType>({
    query: ParentMessageQuery,
    variables: { messageId: ancestorMessageId },
    fetchPolicy: 'no-cache',
  });
  const ancestorMessage2 = data2.website?.findMessage?.parentMessage;
  if (ancestorMessage2) {
    ancestorMessage.parentMessage = ancestorMessage2;
  }
  return true;
}
